"use client";
import { getCategoryCard } from "@/services/categoryCardService";
import { classNameType } from "@/types/generalTypes";
import { useMutation } from "@tanstack/react-query";
import { useCallback, useEffect, useState } from "react";
import CategorySkeleton from "./CategorySkeleton";
import { CategoryDataList } from "@/types/CategoryType";
import CategoryCard from "./CategoryCard";

function CategorySection({ className }: classNameType) {
  const { mutateAsync: getCategoryCardProduct, isPending } = useMutation({
    mutationFn: getCategoryCard,
    retry: 2,
    retryDelay: 1000,
  });
  const [categoryCards, setCategoryCards] = useState<CategoryDataList[]>([]);

  const getAllCategoryCard = useCallback(async () => {
    try {
      const response = await getCategoryCardProduct({
        selected: true,
        take: 7,
      });
      if (response?.isSuccess) {
        setCategoryCards(response.data);
      }
    } catch (err) {
      console.log("error in fetch all data for last offers ", err);
    }
  }, [getCategoryCardProduct]);

  useEffect(() => {
    getAllCategoryCard();
  }, [getAllCategoryCard]);

  return (
    <div className="lg:px-16 sm:px-6 px-4 grid-cols-2 min-[450px]:grid-cols-3 sm:grid-cols-4 grid lg:grid-cols-7 justify-start gap-2 xl:gap-4 xxl:gap-8 my-5 lg:my-5">
      {isPending ? (
        <CategorySkeleton />
      ) : (
        categoryCards?.map((category) => (
          <CategoryCard
            key={category?.id}
            className={className}
            category={category}
          />
        ))
      )}
    </div>
  );
}

export default CategorySection;
